(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hb-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hb-delivery-estimate')) {
 customElements.define('hb-delivery-estimate', class extends HTMLElement {
  async connectedCallback() {
   this.ready = false;
   this.onWake = () => this.update();
   document.addEventListener('visibilitychange', this.onWake);
   window.addEventListener('pageshow', this.onWake);
   if (!this.constructor.countryRequest) {
    const root = window.Shopify?.routes?.root || '/';
    this.constructor.countryRequest = fetch(`${root}browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false`, {signal:AbortSignal.timeout(4000)})
     .then(response => response.ok ? response.json() : null)
     .then(data => data?.detected_values?.country?.handle)
     .catch(() => null);
   }
   const detected = await this.constructor.countryRequest;
   if (!this.isConnected) return;
   if (typeof detected === 'string' && /^[A-Z]{2}$/.test(detected)) this.dataset.country = detected;
   const domestic = this.dataset.country === 'MA';
   this.dataset.productionMin = '5';
   this.dataset.productionMax = '7';
   this.dataset.shippingMin = domestic ? '1' : '7';
   this.dataset.shippingMax = domestic ? '2' : '20';
   this.dayKey = null;
   this.ready = true;
   this.update();
  }
  update() {
   if (!this.ready) return;
   clearTimeout(this.timer);
   const now = new Date();
   const parts = new Intl.DateTimeFormat('en-CA', {timeZone:this.dataset.country === 'MA' ? this.dataset.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone, year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23', calendar:'gregory', numberingSystem:'latn'}).formatToParts(now);
   const civil = Object.fromEntries(parts.map(part => [part.type, part.value]));
   const key = `${civil.year}-${civil.month}-${civil.day}`;
   if (key !== this.dayKey) {
    this.dayKey = key;
    const production = [Number(this.dataset.productionMin), Number(this.dataset.productionMax)].sort((a,b) => a-b);
    const shipping = [Number(this.dataset.shippingMin), Number(this.dataset.shippingMax)].sort((a,b) => a-b);
    const base = Date.UTC(Number(civil.year), Number(civil.month)-1, Number(civil.day), 12);
    const formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en', {timeZone:'UTC', calendar:'gregory', day:'numeric', month:'long'});
    const productionEnd = days => {
     const date = new Date(base);
     let remaining = days;
     while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) remaining--;
     }
     return date.getTime();
    };
    const earliest = formatter.format(new Date(productionEnd(production[0]) + shipping[0]*86400000));
    const latest = formatter.format(new Date(productionEnd(production[1]) + shipping[1]*86400000));
    const message = this.querySelector('[data-message]').content.textContent;
    const [lead, rest] = message.split('__EARLIEST__');
    const [between, tail] = rest.split('__LATEST__');
    const start = document.createElement('strong');
    const end = document.createElement('strong');
    start.textContent = earliest;
    end.textContent = latest;
    this.querySelector('[data-estimate]').replaceChildren(document.createTextNode(lead), start, document.createTextNode(between), end, document.createTextNode(tail));
    this.hidden = false;
   }
   this.timer = setTimeout(() => this.update(), 60000 - Number(civil.second)*1000 - now.getMilliseconds() + 50);
  }
  disconnectedCallback() {
   this.ready = false;
   clearTimeout(this.timer);
   document.removeEventListener('visibilitychange',this.onWake);
   window.removeEventListener('pageshow',this.onWake);
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hb-quantity-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hb-quantity-offers')) {
 class HilaliOffers extends HTMLElement {
  connectedCallback() {
   this.variants = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
   this.host = this.closest('.shopify-section');
   this.syncSelection = () => {
    const input = this.host?.querySelector('product-form-component input[name="quantity"], quantity-selector-component input[name="quantity"], input[name="quantity"]');
    const quantity = Math.max(1, Number(input?.value) || 1);
    if (quantity > 1 && quantity !== this.previousQuantity) this.querySelector('details').open = true;
    this.previousQuantity = quantity;
    this.querySelectorAll('[data-qty]').forEach(card => {
     const tier = quantity >= 6 ? 6 : quantity >= 3 ? 3 : quantity;
     const selected = Number(card.dataset.qty) === tier;
     card.toggleAttribute('data-best', selected);
     card.setAttribute('aria-pressed', String(selected));
    });
   };
   this.sync = () => {
    this.syncSelection();
    const id = this.host?.querySelector('product-form-component input[name="id"]')?.value;
    const variant = this.variants.find(v => String(v.id) === String(id));
    if (!variant) return;
    const format = value => new Intl.NumberFormat(this.dataset.locale, {style:'currency', minimumFractionDigits:0, maximumFractionDigits:0, useGrouping:false,currency:this.dataset.currency}).format(value / 100);
    this.querySelectorAll('[data-qty]').forEach(card => {
     const input = this.host?.querySelector('input[name="quantity"]');
     const qty = card.hasAttribute('data-min-tier') ? Math.max(6, Number(input?.value) || 6) : Number(card.dataset.qty), total = Math.round(variant.price * qty * Number(card.dataset.factor));
     card.querySelector('[data-unit]').textContent = format(total / qty);
     card.querySelector('[data-unit-before]').textContent = format(variant.price);
     const original = card.querySelector('[data-original]');
     if (original) original.textContent = format(variant.price * qty);
     const count = card.querySelector('[data-quantity]');
     if (count) count.textContent = String(qty);
     card.querySelector('[data-total]').textContent = format(total);
     const savings = card.querySelector('[data-savings]');
     if (savings) savings.textContent = format(variant.price * qty - total);
    });
    const quantity = Math.max(1, Number(this.host?.querySelector('input[name="quantity"]')?.value) || 1);
    const current = this.querySelector('[data-current]');
    current.hidden = quantity < 4 || quantity >= 6;
    current.textContent = `${quantity} ${this.dataset.pieces}: ${format(variant.price * quantity)} → ${format(Math.round(variant.price * quantity * 0.88))} · ${this.dataset.save}: ${format(variant.price * quantity - Math.round(variant.price * quantity * 0.88))}`;
   };
   this.observer = new MutationObserver(records => { if (records.some(record => !this.contains(record.target))) this.sync(); });
   if (this.host) this.observer.observe(this.host,{subtree:true,childList:true,attributes:true,attributeFilter:['value']});
   this.host?.addEventListener('change',this.sync);
   this.host?.addEventListener('input',this.sync);
   this.chooseOffer = event => {
    const card = event.target.closest('button[data-qty]');
    if (!card || !this.contains(card)) return;
    const input = this.host?.querySelector('product-form-component input[name="quantity"], quantity-selector-component input[name="quantity"], input[name="quantity"]');
    if (!input || input.disabled) return;
    const quantity = card.hasAttribute('data-min-tier') ? Math.max(6, Number(input.value) || 6) : Number(card.dataset.qty);
    if (quantity < Number(input.min || 1) || (input.max && quantity > Number(input.max)) || (quantity - Number(input.min || 1)) % Number(input.step || 1)) return;
    input.value = String(quantity);
    input.dispatchEvent(new Event('input', {bubbles:true}));
    input.dispatchEvent(new Event('change', {bubbles:true}));
    this.sync();
   };
   this.addEventListener('click',this.chooseOffer);
   this.onQuantityClick = () => { cancelAnimationFrame(this.quantityFrame); this.quantityFrame = requestAnimationFrame(this.sync); };
   this.host?.addEventListener('click',this.onQuantityClick);
   this.sync();
  }
  disconnectedCallback(){this.removeEventListener('click',this.chooseOffer);this.observer?.disconnect();this.host?.removeEventListener('change',this.sync);this.host?.removeEventListener('input',this.sync);this.host?.removeEventListener('click',this.onQuantityClick);cancelAnimationFrame(this.quantityFrame);}
 }
 customElements.define('hb-quantity-offers',HilaliOffers);
}
  } catch(e) { console.error(e); }
})();

})();
